"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = __importDefault(require("swiper"));
var modules_1 = require("swiper/modules");
var handleTestimonials = function () {
    console.log('handleTestimonials');
    var swiper = new swiper_1.default('.testimonials__swiper', {
        modules: [modules_1.Navigation, modules_1.EffectFade, modules_1.Autoplay],
        loop: true,
        autoplay: {
            delay: 30000,
        },
        effect: "fade",
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        navigation: {
            nextEl: '.testimonials__swiper-button-next',
            prevEl: '.testimonials__swiper-button-prev',
        },
    });
};
document.addEventListener('DOMContentLoaded', function () {
    handleTestimonials();
});
